import { toast } from '@/components/toast';
import { isAgentV2 } from '@/pages/avatar/hooks/useAgentIsV2';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { useClientKey } from '@/state/agent';
import { AppRoutes } from '@/utils/types';
import { AgentStatus, IAgent } from '@d-id/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { V2UpgradeSuccessToast } from '../components/V2UpgradeSuccessToast';

const INITIAL_STATUSES_COUNTER = {
    [AgentStatus.Done]: 0,
    [AgentStatus.Started]: 0,
    [AgentStatus.Error]: 0,
    [AgentStatus.Created]: 0,
    [AgentStatus.Rejected]: 0,
    [AgentStatus.Ready]: 0,
};

export const usePollingStatus = (items?: IAgent[]) => {
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const { isAnonymous } = useAuth();
    const { data: clientKey } = useClientKey({ isAnonymous });
    const [videosStatusCount, setVideosStatusCount] = useState(INITIAL_STATUSES_COUNTER);

    const onSubmit = async () => {
        if (clientKey) {
            toast.dismiss('agent-generate-success');
            navigate(`${AppRoutes.AgentShare}`, { state: { isOwner: true, agent: items?.[0], clientKey: clientKey.client_key } });
        }
    }

    useEffect(() => {
        if (items) {
            const newAgentsStatusCount = items.reduce(
                (res, item) => ({ ...res, [item.status]: res[item.status as AgentStatus] + 1 }),
                INITIAL_STATUSES_COUNTER
            );

            if (videosStatusCount !== INITIAL_STATUSES_COUNTER) {
                if (videosStatusCount[AgentStatus.Done] < newAgentsStatusCount[AgentStatus.Done]) {
                    if (isAgentV2(items?.[0]?.id)) {
                        toast.success({
                            render: V2UpgradeSuccessToast({ onClose: () => toast.dismiss('agent-generate-success'), onSubmit }),
                            toastId: 'agent-generate-success',
                            options: { position: 'bottom-right', containerWidth: 740 },
                        });
                    } else {
                        toast.success({ title: `We've successfully generated your Agent!`, toastId: 'agent-generate-success' });
                    }
                    mixpanel?.track('agent-create', { event: 'success' });
                }

                if (videosStatusCount[AgentStatus.Error] < newAgentsStatusCount[AgentStatus.Error]) {
                    mixpanel?.track('agent-create', { event: 'error' });
                    toast.error({ title: `We can't generate your Agent right now`, toastId: 'agent-generate-fail' });
                }
            }

            setVideosStatusCount(newAgentsStatusCount);
        }
    }, [items?.length]);
};
